import React from 'react'

import { lastDayOfMonth } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { Box, ColumnContent, Flex, HStack } from '@enechain/ecloud-designsystem'
import { FilterContent } from '@enechain/eposition-ui'

import { ContractPeriodFilter } from '~/pages/ContractList/components/FilterSection/PeriodFilter'
import { SettledFilter } from '~/pages/ContractList/components/FilterSection/SettledFilter'
import {
  ContractListFilterState,
  PeriodFilterType,
} from '~/pages/ContractList/hooks/useContractListFilter'

type Props = {
  filterState: ContractListFilterState
  updateFilter: (updates: Partial<ContractListFilterState>) => void
}

export const ContractFilterSection: React.FC<Props> = ({
  filterState,
  updateFilter,
}) => {
  const { t } = useTranslation(['page'])
  return (
    <FilterContent>
      <HStack
        gap="6"
        justifyContent="flex-start"
        alignItems="flex-start"
        height="full"
      >
        <Box minWidth="160px">
          <ColumnContent label={t('page:contract_list.filter.delivery_period')}>
            <ContractPeriodFilter
              fromDate={filterState.fromDate}
              toDate={filterState.toDate}
              onChange={(
                fromDate?: Date,
                toDate?: Date,
                filterType?: PeriodFilterType,
              ): void => {
                updateFilter({
                  fromDate,
                  toDate:
                    toDate !== undefined ? lastDayOfMonth(toDate) : undefined,
                  filterType,
                })
              }}
            />
          </ColumnContent>
        </Box>
        <Box minWidth="160px">
          <ColumnContent
            label={t('page:contract_list.filter.display_conditions_label')}
          >
            <Flex gap="2" height="40px" alignItems="center">
              <SettledFilter
                excludeSettled={filterState.excludeSettled}
                onExcludeSettledChange={(excludeSettled: boolean): void => {
                  updateFilter({ excludeSettled })
                }}
              />
            </Flex>
          </ColumnContent>
        </Box>
      </HStack>
    </FilterContent>
  )
}
